import { RootState } from '../../store';

export const getRuleSelector = (state: RootState) => state?.ruleReducer?.rule;
